<template>
  <v-row v-if="view" align="center" class="ma-0 pa-0">
    <v-col cols="12" class="pa-0">
      <v-card flat class="ma-0 pa-0 overflow-y-auto" color="transparent" :style="contentsHeight + ' overflow-x: hidden;'">
        <!-- <template v-for="item in group"> -->
          <v-row align="center" class="ma-0 pa-0" v-for="item in group" :key="item + 'header'">
            <v-col cols="12" class="pa-0 b-B-TITLE">
              <v-row class="ma-0 pa-0" align="center">
                <v-col cols="4" class="pa-0" align="start">
                  <v-card-title class="pb-0">{{ getName(item) }}</v-card-title>
                </v-col>
                <v-col cols="8" class="py-0" align="end">
                  <template v-if="item != '*'">
                    <template v-if="items[item].key">
                      <v-avatar size="30">
                        <img v-if="getAvatar(item)" :src='getAvatar(item)'>
                        <v-avatar v-else size="30" color="primary"><span class="font-weight-bold white--text" style="font-size:22px; user-select: none;">{{ getNamePrefix(item) }}</span></v-avatar>
                      </v-avatar>
                      <v-chip color="#757575" dark small depressed disabled class="mx-1">
                        <span class="caption">{{ '更新日時: ' + getLastUpdate(item) }}</span>
                      </v-chip>
                      <v-chip color="#757575" dark small depressed disabled>
                        <span class="caption">{{ '更新回数: ' + items[item].revision }}</span>
                      </v-chip>
                    </template>
                    <v-btn v-if="modify[item]" dark rounded depressed small color="error" class="mx-1" @click="store = item, dialog = true"><span>保存</span></v-btn>
                    <v-btn v-if="modify[item]" dark rounded depressed small outlined color="error" @click="onReset(item)"><span>取消</span></v-btn>
                    <v-btn fab x-small depressed color="primary" @click="onFileExport(item)" class="mx-1"><span class="font-weight-bold white--text"><v-icon>mdi-upload</v-icon></span></v-btn>
                    <input @change="onFileImport" type="file" name="file" accept="text/csv" :ref="item">
                    <v-btn fab x-small depressed color="primary" @click.stop="onFileSelect(item)"><span class="font-weight-bold white--text"><v-icon>mdi-download</v-icon></span></v-btn>
                  </template>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-card-text :key="item">
                <v-row align="center" class="ma-0 pa-0">
                  <v-col cols="2" class="pa-0">
                    <v-toolbar flat height="21" color="transparent" >
                      <v-spacer></v-spacer>
                      <v-btn dark small icon @click.stop.prevent="onToggle(item, 0)">
                        <v-icon v-if="checkToggle(item, 0)" :color="pColor(item)">mdi-menu-up</v-icon>
                        <v-icon v-else :color="pColor(item)">mdi-menu-down</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </v-col>
                  <v-col cols="10" class="pa-0">
                    <v-row align="center" class="ma-0 pa-0">
                       <v-col class="pa-0" align="center" v-for="i in 13" :key="i">
                          <v-sheet
                            :color="year == getFY() && mm == i ? pColor(item) : getWeekColor(1)"
                            dark
                            height="21"
                            :key="i"
                            tile
                            :class="i == 13 ? 'b-L-GREY b-R-GREY b-T-GREY text-center' : 'b-L-GREY b-T-GREY text-center'"
                          >
                            <span :class="year == getFY() && mm == i ? 'white--text' : 'secondary--text'">{{ getMonth(i) }}</span>
                          </v-sheet>
                       </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <template v-for="(metric, index) in feeHeaders">
                  <v-row v-if="data && checkHide(item, metric.group) && metric.roles[getPrivilege(data)]" align="center" class="ma-0 pa-0 text-right" :key="index">
                    <v-col cols="2" class="pa-0">
                      <v-sheet color="transparent" tile :class="(feeHeaders.length - 1) == index ? 'b-L-GREY b-T-GREY b-B-GREY' : 'b-L-GREY b-T-GREY'" height="21">
                        <template v-if="metric.type != 'header'">
                          <span :class="metric.type == 'none' ? 'pl-4 white--text' : 'pl-4'">{{ metric.name + '（' + metric.sufix + '）' }}</span>
                        </template>
                        <template v-else>
                          <v-toolbar flat :color="!checkGroup(metric) ? pColor(item) : sColor" height="20">
                            <span class="white--text">{{ metric.name }}</span>
                            <v-spacer></v-spacer>
                            <template v-if="checkExpand(item, metric.key)">
                              <v-btn dark small icon @click.stop.prevent="onToggle(item, metric.key)">
                                <v-icon v-if="checkToggle(item, metric.key)">mdi-menu-up</v-icon>
                                <v-icon v-else>mdi-menu-down</v-icon>
                              </v-btn>
                            </template>
                          </v-toolbar>
                        </template>
                      </v-sheet>
                    </v-col>
                    <v-col cols="10" class="pa-0">
                      <v-row align="center" class="ma-0 pa-0">
                        <v-col class="pa-0" v-for="i in 13" :key="i">
                          <v-sheet
                            :class="getBackgroundColor (mm, i, index)"
                            :color="checkValue(item, i, index, metric)"
                            height="21"
                            :key="i"
                            tile
                          >
                            <template v-if="item != '*'">
                              <template v-if="i != 13">
                                <template v-if="!checkGroup(metric) && checkInput(metric)">
                                  <input
                                    type="number"
                                    :value="getValue(item, i, index, metric)"
                                    :class="metric.type == 'header' && year == getFY() && mm == i ? 'white--text' : ''"
                                    style="text-align: right; width: 100%;"
                                    :disabled="metric.type == 'header' && metric.key < 300 && metric.key != 100"
                                    @change="onChange($event, item, i, metric)"
                                  />
                                </template>
                                <template v-else>
                                  <span
                                    style="text-align: right; width: 100%;"
                                    :class="metric.type == 'header' && year == getFY() && mm == i ? 'pr-1 white--text font-weight-bold' : 'pr-1'"
                                  >
                                    {{ getValue(item, i, index, metric) }}
                                  </span>
                                </template>
                              </template>
                              <template v-else>
                                <span
                                  style="text-align: right; width: 100%;"
                                  class="pr-1 font-weight-bold"
                                >
                                  {{ getTotalValue(item, index, metric) }}
                                </span>
                              </template>
                            </template>
                            <template v-else>
                              <span v-if="i != 13"
                                style="text-align: right; width: 100%;"
                                :class="metric.type == 'header' && year == getFY() && mm == i ? 'pr-1 white--text select-none' : 'pr-1 select-none'"
                              >
                                {{ getValue(item, i, index, metric) }}
                              </span>
                              <span v-else
                                style="text-align: right; width: 100%;"
                                class="pr-1 font-weight-bold select-none"
                              >
                                {{ getTotalValue(item, index, metric) }}
                              </span>
                            </template>
                          </v-sheet>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-col>
          </v-row>
        <!-- </template> -->
      </v-card>
    </v-col>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        title='更新'
        message='データを保存します。よろしいですか？'
        :dialog='dialog'
        :cancel='true'>
      </app-basic-dialog>
    </div>

  </v-row>
  <v-row v-else class="ma-0 pa-0">
    <template v-if="type == 'metric'">
      <v-col cols="12" class="pa-0" align="center">
        <v-row class="ma-0 pa-0" style="height: 70px;">
          <v-col :cols="checkExtension() ? 4 : 6" align="center" class="pa-0">
            <v-card flat tile height="70" class="title-orange">
              <v-sheet tile color="lime darken-4" class="caption white--text select-none">単価平均</v-sheet>
              <v-card-text class="pa-0">
                <span class="headline black--text select-none" style="line-height:50px;">{{ items[g][m][117].value }}</span>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col :cols="checkExtension() ? 8 : 6" align="center" class="pa-0">
            <v-row class="ma-0 pa-0">
              <!-- <template v-for="(item, index) in checkExtension() ? kpis_extension_1 : kpis"> -->
                <v-col :cols="checkExtension() ? 3 : 4" class="pa-0" v-for="(item, index) in checkExtension() ? kpis_extension_1 : kpis" :key="index">
                  <v-card flat tile height="70" class="title-orange">
                    <v-sheet tile color="lime darken-4" class="caption white--text select-none overflow-text-hidden">{{ item.title }}</v-sheet>
                    <v-card-text class="pa-0">
                      <v-row class="ma-0">
                        <v-col cols="12" class="pa-0">
                          <span class="caption black--text select-none" style="line-height:50px;">{{ items[g][m][item.index].value }}</span>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              <!-- </template> -->
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </template>
    <template v-else-if="type == 'graph'">
      <v-sheet width="100%">
        <template-metrics-graph
          :type="'fee'"
          :height="300"
          :group="g"
          :tempGroups="tempGroups"
          :compare="'N/A'"
          :fees="items"
          :year="year"
        >
        </template-metrics-graph>
      </v-sheet>
    </template>
  </v-row>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import * as Papa from 'papaparse'
import moment from 'moment-timezone'
export default {
  computed: {
    ...mapGetters({
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      metricsActs: 'metricsActs/metrics',
      metricsRevises: 'metricsRevises/metrics',
      metricsFees: 'metricsFees/metrics',
      feeHeaders: 'metricsFees/headers',
      windowSize: 'shared/windowSize',
      preschool: 'shared/preschool',
      extension: 'shared/extension'
    }),
    contentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 60 - 40) + 'px;'
    }
  },
  props: [ 'view', 'type', 'g', 'm', 'tempGroups', 'school', 'year', 'group', 'sColor' ],
  data () {
    return {
      dialog: false,
      store: null,
      mm: 0,
      modify: {},
      acts: {},
      revises: {},
      items: {},
      expansions: [],
      kpis: [
        { title: '小学部', index: 114 },
        { title: '中学部', index: 115 },
        { title: '高校部', index: 116 }
      ],
      kpis_extension_1: [
        { title: '幼児部', index: 130 },
        { title: '小学部', index: 114 },
        { title: '中学部', index: 115 },
        { title: '高校部', index: 116 }
      ]
    }
  },
  watch: {
    year () {
      this.createData()
    },
    metricsActs () {
      this.createData()
    },
    metricsRevises () {
      this.createData()
    },
    metricsFees (nV, oV) {
      var temp = {}
      for (var i in nV) {
        var gkey = Object.keys(nV[i].groups)
        if (temp[gkey[0]]) {
          if (temp[gkey[0]].revision < nV[i].revision) {
            temp[gkey[0]] = nV[i]
          }
        } else {
          temp[gkey[0]] = nV[i]
        }
      }
      var keys = Object.keys(temp)
      for (i in keys) {
        if (this.items[keys[i]]) {
          if (this.items[keys[i]].revision !== temp[keys[i]].revision) {
            this.dataRead(keys[i])
          }
        }
      }
      this.calcVA()
    }
  },
  created () {
    moment.tz.setDefault('Asia/Tokyo')
    var mm = moment().month()
    this.mm = mm > 2 ? mm - 2 : mm + 10
    this.createData()
  },
  methods: {
    createData () {
      for (var i in this.tempGroups) {
        Vue.set(this.expansions, this.tempGroups[i].key, [
          { key: 0, group: '', value: true, enable: true },
          { key: 17, group: 'A', value: true, enable: true },
          { key: 117, group: 'B', value: true, enable: true },
          { key: 217, group: 'C', value: true, enable: true }
        ])
      }
      this.actsRead()
      this.reviseRead()
      for (var g in this.tempGroups) {
        this.dataRead(this.tempGroups[g].key)
      }
      for (g in this.tempGroups) {
        for (i = 0; i < 12; i++) {
          this.calcV(this.tempGroups[g].key, i, 114) // 単価平均算出
        }
      }
      this.calcVA()
    },
    checkExtension () {
      if (this.preschool) {
        if (this.extension === 1) {
          return true
        }
      }
      return false
    },
    actsRead () {
      var vm = this
      var temp = {}
      for (var i in this.tempGroups) {
        for (var x = 0; x < 12; x++) {
          temp[this.tempGroups[i].key] = [
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []],
            [[], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], [], []]
          ]
        }
      }
      var acts = this.metricsActs.filter(function (metric) {
        return metric.yyyy === vm.year
      })
      var counter = (this.preschool && this.extension === 1) ? 31 : 18
      for (i in acts) {
        for (var y = 0; y < counter; y++) {
          for (var item in acts[i][y]) {
            var keys = Object.keys(acts[i][y][item].groups)
            for (var k in keys) {
              var index = this.groups.findIndex(g => g.key === keys[k])
              if (index === -1) {
                continue
              } else if (!this.groups[index].enable) {
                continue
              }
              if (acts[i][y][item].groups[keys[k]] && typeof temp[keys[k]] !== 'undefined') {
                temp[keys[k]][acts[i].mm][y].push(acts[i][y][item])
                temp['*'][acts[i].mm][y].push(acts[i][y][item])
              }
            }
          }
        }
      }
      this.acts = temp
    },
    reviseRead () {
      var vm = this
      var revises = this.metricsRevises.filter(function (metric) {
        return metric.year === vm.year
      })
      this.revises = {}
      for (var i in revises) {
        var keys = Object.keys(revises[i].groups)
        for (var k in keys) {
          if (revises[i].groups[keys[k]]) {
            this.revises[keys[k]] = JSON.parse(JSON.stringify(revises[i]))
          }
        }
        if (typeof this.revises['*'] === 'undefined') {
          this.revises['*'] = JSON.parse(JSON.stringify(revises[i]))
        } else {
          for (var x = 0; x < 12; x++) {
            if (revises[i][x].enable) {
              var counter = (this.preschool && this.extension === 1) ? 31 : 18
              for (var y = 1; y < counter; y++) {
                if (typeof this.revises['*'][x][y] !== 'undefined') {
                  this.revises['*'][x][y].value += revises[i][x][y].value
                }
              }
              if (revises[i][x].enable) {
                this.revises['*'][x].enable = true
              }
            }
          }
        }
      }
    },
    dataRead (group) {
      var vm = this
      var headers = JSON.parse(JSON.stringify(this.feeHeaders))
      var metrics = JSON.parse(JSON.stringify(this.metricsFees))
      var path = 'metricsFees/initial'
      var metric = null
      var index = metrics.findIndex(item => item.groups[group] && item.year === this.year)
      if (index !== -1) {
        var temp = metrics.filter(function (item) {
          if (item.groups[group] && item.year === vm.year) {
            return true
          }
          return false
        })
        temp.sort(function (a, b) {
          if (a.revision > b.revision) return -1
          if (a.revision < b.revision) return 1
          return 0
        })
        metric = JSON.parse(JSON.stringify(temp[0]))
        for (var i = 0; i < 12; i++) {
          for (var x = 0; x < headers.length; x++) {
            if (typeof metric[i][headers[x].key] !== 'undefined') {
              metric[i][headers[x].key].modify = false
            } else {
              metric[i][headers[x].key] = {
                value: 0,
                modify: false
              }
            }
          }
          if (typeof metric[i][100] === 'undefined') {
            metric[i][100] = {
              value: 0,
              modify: false
            }
            metric[i][200] = {
              value: 0,
              modify: false
            }
          }
          var vc = 0
          var v = 0
          if (this.preschool && this.extension === 1) {
            if (metric[i][130].value !== 0) {
              vc += 1
              v += metric[i][130].value
            }
          } else if (this.preschool) {
            if (metric[i][100].value !== 0) {
              vc += 1
              v += metric[i][100].value
            }
          }
          if (metric[i][114].value !== 0) {
            vc += 1
            v += metric[i][114].value
          }
          if (metric[i][115].value !== 0) {
            vc += 1
            v += metric[i][115].value
          }
          if (metric[i][116].value !== 0) {
            vc += 1
            v += metric[i][116].value
          }
          var r = Math.floor(v / vc)
          r = isNaN(r) || r === Infinity ? 0 : r
          metric[i][117].value = r
        }
      } else {
        metric = JSON.parse(JSON.stringify(this.$store.getters[path]))
        for (i = 0; i < 12; i++) {
          for (x = 0; x < headers.length; x++) {
            metric[i][headers[x].key] = {
              value: 0,
              modify: false
            }
          }
        }
      }
      Vue.set(this.items, group, JSON.parse(JSON.stringify(metric)))
      for (i = 0; i < 12; i++) {
        if (this.preschool) {
          if (this.extension === 1) {
            for (x = 101; x < 114; x++) {
              this.calcVS(group, i, x)
            }
            for (x = 126; x < 130; x++) {
              this.calcVS(group, i, x)
            }
          } else {
            for (x = 100; x < 114; x++) {
              this.calcVS(group, i, x)
            }
          }
        } else {
          for (x = 101; x < 114; x++) {
            this.calcVS(group, i, x)
          }
        }
      }
    },
    calcVA (mm) {
      if (typeof this.items['*'] === 'undefined') {
        return
      }
      var headers = JSON.parse(JSON.stringify(this.feeHeaders))
      var temp = JSON.parse(JSON.stringify(this.items['*']))

      if (mm) {
        for (var x = 0; x < headers.length; x++) {
          temp[mm][headers[x].key] = {
            value: 0
          }
        }
      } else {
        for (var i = 0; i < 12; i++) {
          for (x = 0; x < headers.length; x++) {
            temp[i][headers[x].key] = {
              value: 0
            }
          }
        }
      }
      for (var g in this.tempGroups) {
        if (this.tempGroups[g].key !== '*') {
          if (mm) {
            for (x = 0; x < headers.length; x++) {
              if (headers[x].key < 200) {
                if (this.items[this.tempGroups[g].key][mm][headers[x].key].value > 0) {
                  temp[mm][headers[x].key].value += this.items[this.tempGroups[g].key][mm][headers[x].key].value * this.getRevisedCount(this.tempGroups[g].key, mm, headers[x].key - 100)
                }
              } else {
                temp[mm][headers[x].key].value += this.items[this.tempGroups[g].key][mm][headers[x].key].value
              }
            }
          } else {
            if (this.items[this.tempGroups[g].key]) {
              for (i = 0; i < 12; i++) {
                for (x = 0; x < headers.length; x++) {
                  if (headers[x].key < 200) {
                    if (this.items[this.tempGroups[g].key][i][headers[x].key].value > 0) {
                      temp[i][headers[x].key].value += this.items[this.tempGroups[g].key][i][headers[x].key].value * this.getRevisedCount(this.tempGroups[g].key, i, headers[x].key - 100)
                    }
                  } else {
                    temp[i][headers[x].key].value += this.items[this.tempGroups[g].key][i][headers[x].key].value
                  }
                }
              }
            }
          }
        }
      }
      if (mm) {
        for (x = 0; x < headers.length; x++) {
          if (headers[x].key < 200) {
            var v = Math.floor(temp[mm][headers[x].key].value + 100 / this.getRevisedCount('*', mm, headers[x].key - 100))
            temp[mm][headers[x].key].value = isNaN(v) || v === Infinity ? 0 : v
          }
        }
      } else {
        for (i = 0; i < 12; i++) {
          for (x = 0; x < headers.length; x++) {
            if (headers[x].key < 200) {
              v = Math.floor(temp[i][headers[x].key + 100].value / this.getRevisedCount('*', i, headers[x].key - 100))
              temp[i][headers[x].key].value = isNaN(v) || v === Infinity ? 0 : v
            }
          }
        }
      }
      this.items['*'] = temp
    },
    getRevisedCount (group, mm, key) {
      var count = 0
      if (this.acts[group]) {
        if (this.revises[group] && this.revises[group][mm].enable) {
          count = this.revises[group][mm][key] ? this.revises[group][mm][key].value : 0
        } else {
          count = this.acts[group][mm][key].length
        }
      }
      return count
    },
    calcV (group, mm, key) {
      var v = 0
      var vc = 0
      var i = 0
      var r = 0
      var count = 0
      for (i = 0; i < 6; i++) {
        count = this.getRevisedCount(group, mm, 1 + i)
        v += this.items[group][mm][101 + i].value * count
        vc += count
      }
      r = Math.floor(v / vc)
      r = isNaN(r) || r === Infinity ? 0 : r
      Vue.set(this.items[group][mm], 114, { value: r, modify: false })

      v = vc = 0
      for (i = 0; i < 3; i++) {
        count = this.getRevisedCount(group, mm, 7 + i)
        v += this.items[group][mm][107 + i].value * count
        vc += count
      }
      r = Math.floor(v / vc)
      r = isNaN(r) || r === Infinity ? 0 : r
      Vue.set(this.items[group][mm], 115, { value: r, modify: false })

      v = vc = 0
      for (i = 0; i < 4; i++) {
        count = this.getRevisedCount(group, mm, 10 + i)
        v += this.items[group][mm][110 + i].value * count
        vc += count
      }
      r = Math.floor(v / vc)
      r = isNaN(r) || r === Infinity ? 0 : r
      Vue.set(this.items[group][mm], 116, { value: r, modify: false })

      if (this.preschool && this.extension === 1) {
        v = vc = 0
        for (i = 0; i < 4; i++) {
          count = this.getRevisedCount(group, mm, 26 + i)
          v += this.items[group][mm][126 + i].value * count
          vc += count
        }
        r = Math.floor(v / vc)
        r = isNaN(r) || r === Infinity ? 0 : r
        Vue.set(this.items[group][mm], 130, { value: r, modify: false })
      }

      v = vc = 0
      if (this.preschool && this.extension !== 1) {
        v += this.items[group][mm][200].value
        vc += this.getRevisedCount(group, mm, 0)
      } else if (this.preschool && this.extension === 1) {
        v += this.items[group][mm][230].value
        vc += this.getRevisedCount(group, mm, 30)
      }
      v += this.items[group][mm][214].value
      vc += this.getRevisedCount(group, mm, 14)
      v += this.items[group][mm][215].value
      vc += this.getRevisedCount(group, mm, 15)
      v += this.items[group][mm][216].value
      vc += this.getRevisedCount(group, mm, 16)

      r = Math.floor(v / vc)
      r = isNaN(r) || r === Infinity ? 0 : r
      Vue.set(this.items[group][mm], 117, { key: 117, value: r, modify: false })
    },
    calcVS (group, mm, key) {
      var v = 0
      var i = 0
      if (this.acts[group]) {
        if (this.revises[group] && this.revises[group][mm].enable) {
          v = this.revises[group][mm][key - 100] ? this.revises[group][mm][key - 100].value : 0
        } else {
          v = this.acts[group][mm][key - 100].length
        }
      }
      v = v * this.items[group][mm][key].value
      Vue.set(this.items[group][mm], 100 + key, { key: 100 + key, value: v, modify: false })

      v = 0
      for (i = 0; i < 6; i++) {
        v += this.items[group][mm][201 + i].value
      }
      Vue.set(this.items[group][mm], 214, { key: 214, value: v, modify: false })

      v = 0
      for (i = 0; i < 3; i++) {
        v += this.items[group][mm][207 + i].value
      }
      Vue.set(this.items[group][mm], 215, { key: 215, value: v, modify: false })

      v = 0
      for (i = 0; i < 4; i++) {
        v += this.items[group][mm][210 + i].value
      }
      Vue.set(this.items[group][mm], 216, { key: 216, value: v, modify: false })

      if (this.preschool && this.extension === 1) {
        v = 0
        for (i = 0; i < 4; i++) {
          v += this.items[group][mm][226 + i].value
        }
        Vue.set(this.items[group][mm], 230, { key: 230, value: v, modify: false })
      }

      v = 0
      if (this.preschool && this.extension !== 1) {
        v += this.items[group][mm][200].value
      }
      if (this.preschool && this.extension === 1) {
        v += this.items[group][mm][230].value
      }
      v += this.items[group][mm][214].value
      v += this.items[group][mm][215].value
      v += this.items[group][mm][216].value
      Vue.set(this.items[group][mm], 217, { key: 217, value: v, modify: false })
    },
    checkUpdate () {
      if (this.group.length === 1 && this.group[0] === '*') {
        return true
      }
      for (var i in this.modify) {
        if (this.modify[i]) {
          return false
        }
      }
      return true
    },
    checkGroup (metric) {
      return metric.key >= 200 && metric.key < 300
    },
    checkInput (metric) {
      if (metric.type !== 'header') {
        return true
      }
      if (metric.key === 100) {
        return true
      }
      return false
    },
    checkToggle (item, key) {
      if (!this.expansions[item]) {
        return false
      }
      var index = this.expansions[item].findIndex(expand => expand.key === key)
      if (index !== -1) {
        return this.expansions[item][index].value
      }
      return false
    },
    checkHide (item, group) {
      if (!this.expansions[item]) {
        return false
      }
      var index = this.expansions[item].findIndex(expand => expand.group === group)
      if (index !== -1) {
        return !this.expansions[item][index].value
      }
      return true
    },
    checkExpand (item, key) {
      if (!this.expansions[item]) {
        return false
      }
      var index = this.expansions[item].findIndex(expand => expand.key === key)
      if (index !== -1) {
        return this.expansions[item][index].enable
      }
      return false
    },
    checkValue (item, i, index, metric) {
      if (metric.type === 'header') {
        if (metric.key !== 100 && metric.key < 200) {
          return this.year === this.getFY() && this.mm === i ? this.pColor(item) : this.getWeekColor(1)
        } else if (metric.key !== 100 && metric.key < 300) {
          return this.year === this.getFY() && this.mm === i ? this.sColor : this.getWeekColor(1)
        } else if (metric.key === 100 || metric.key > 300) {
          if (this.items[item] && i !== 13 && this.items[item][i - 1][metric.key].modify) {
            return '#ff8bff'
          }
          if (item !== '*') {
            return this.year === this.getFY() && this.mm === i ? this.pColor(item) : 'transparent'
          }
          return this.year === this.getFY() && this.mm === i ? this.pColor(item) : this.getWeekColor(1)
        }
      }
      if (this.items[item] && i !== 13 && this.items[item][i - 1][metric.key].modify) {
        return '#ff8bff'
      }
      if (item === '*') {
        return 'transparent'
      }
      if (this.checkGroup(metric)) {
        return 'transparent'
      }
      return 'transparent'
    },
    pColor (group) {
      var color = 'lime darken-4'
      if (group !== '*') {
        var index = this.groups.findIndex(g => g.key === group)
        if (index !== -1) {
          if (typeof this.groups[index].color !== 'undefined') {
            color = this.groups[index].color
          }
        }
      }
      return color
    },
    getName (item) {
      if (item === '*') {
        return '全校'
      }
      var index = this.groups.findIndex(group => group.key === item)
      if (index !== -1) {
        return this.groups[index].name
      }
      return ''
    },
    getAvatar (item) {
      var url = null
      var index = this.users.findIndex(user => user.key === this.items[item].author)
      if (index !== -1) {
        if (this.users[index].avatar) {
          url = this.users[index].avatar.thumbnail
        }
      }
      return url
    },
    getNamePrefix (item) {
      var name = '？'
      var index = this.users.findIndex(user => user.key === this.items[item].author)
      if (index !== -1) {
        if (this.users[index].name) {
          name = this.users[index].name.slice(0, 1)
        }
      }
      return name
    },
    getImageLink (item) {
      var index = this.users.findIndex(user => user.key === this.items[item].author)
      if (index !== -1) {
        if (this.users[index].avatar) {
          return this.users[index].avatar.thumbnail
        }
      }
      return null
    },
    getLastUpdate (item) {
      return moment(this.items[item].updatedAt).format('YYYY-MM-DD HH:mm')
    },
    getValue (item, i, index, metric) {
      var value = 0
      if (this.items[item]) {
        value = this.items[item][i - 1][metric.key].value
      }
      return value
    },
    getTotalValue (item, index, metric) {
      var a = 0
      var ac = 0
      if (!this.items[item]) {
        return 0
      }
      for (var x = 0; x < 12; x++) {
        if (typeof this.items[item][x][metric.key] !== 'undefined') {
          var v = this.items[item][x][metric.key].value
          a += v
          if (v !== 0) {
            ac += 1
          }
        }
      }
      var r = Math.floor(a / ac)
      return isNaN(r) || r === Infinity ? '0' : r
    },
    getBackgroundColor (mm, i, index) {
      var color = (i === 13 ? 'd-flex b-L-GREY b-R-GREY b-T-GREY' : 'd-flex b-L-GREY b-T-GREY')
      if ((this.feeHeaders.length - 1) === index) {
        color += ' b-B-GREY'
      }
      return color
    },
    onChange (event, item, mm, metric) {
      var v = parseInt(event.target.value) === '' || isNaN(parseInt(event.target.value)) ? Number(0) : parseInt(event.target.value)
      Vue.set(this.items[item][mm - 1], metric.key, { key: v, value: v, modify: true })
      this.modify[item] = true
      this.calcV(item, mm - 1, metric.key)
      this.calcVS(item, mm - 1, metric.key)
      this.calcVA(mm - 1)
    },
    onToggle (item, key) {
      var index = this.expansions[item].findIndex(expand => expand.key === key)
      if (index !== -1) {
        this.expansions[item][index].value = !this.expansions[item][index].value
        if (key === 0) {
          for (var i in this.expansions[item]) {
            this.expansions[item][i].value = this.expansions[item][index].value
          }
        }
      }
    },
    onFileExport (item) {
      var temp = []
      var name = this.getName(item)

      const config = {
        delimiter: ',', // 区切り文字
        header: true, // キーをヘッダーとして扱う
        newline: '\n' // 改行
      }
      for (var i = 0; i < 12; i++) {
        var headers = JSON.parse(JSON.stringify(this.feeHeaders))
        for (var x in headers) {
          var v = JSON.parse(JSON.stringify(this.items[item][i][headers[x].key]))
          v['yyyy'] = this.year
          v['mm'] = i < 9 ? i + 4 : i - 8
          v['item'] = headers[x].key
          temp.push(v)
        }
      }
      const delimiterString = Papa.unparse(temp, config)
      const blobUrl = new Blob([delimiterString], { type: 'text/csv' })
      const blob = blobUrl
      const aTag = document.createElement('a')

      aTag.download = this.year + '-' + name + '.csv'

      if (window.navigator.msSaveBlob) {
        // for IE
        window.navigator.msSaveBlob(blob, aTag.download)
      } else if (window.URL && window.URL.createObjectURL) {
        // for Firefox
        aTag.href = window.URL.createObjectURL(blob)
        document.body.appendChild(aTag)
        aTag.click()
        document.body.removeChild(aTag)
      } else if (window.webkitURL && window.webkitURL.createObject) {
        // for Chrome
        aTag.href = (window.URL || window.webkitURL).createObjectURL(blob)
        aTag.click()
      } else {
        // for Safari
        window.open(
          `data:type/csv;base64,${window.Base64.encode(this.state.content)}`,
          '_blank'
        )
      }
    },
    onFileImport (e) {
      var vm = this
      vm.file = null
      e.preventDefault()
      let files = e.target.files
      if (files.length === 0) {
        return
      }
      this.file = files[0]
      var reader = new FileReader()
      reader.onerror = function () {
        // console.log('error')
      }
      this.loading = true
      var headers = JSON.parse(JSON.stringify(this.feeHeaders))
      reader.onload = function () {
        Papa.parse(files[0], {
          encoding: 'UTF8',
          header: true,
          complete: function (results) {
            vm.modify[vm.item] = true
            for (var i in results.data) {
              if (results.data[i].yyyy !== 'yyyy') {
                var mm = parseInt(results.data[i].mm)
                mm = mm < 4 ? mm + 8 : mm - 4
                var item = parseInt(results.data[i].item)
                var value = parseInt(results.data[i].value)
                var index = headers.findIndex(h => h.key === item)
                if (index !== -1) {
                  vm.items[vm.item][mm][item].value = value
                  vm.items[vm.item][mm][item].modify = true
                }
              }
            }
            vm.$emit('changed', vm.item)
            e.target.value = ''
            vm.loading = false
          },
          error () {
            e.target.value = ''
            vm.loading = false
          }
        })
      }
      const pause = ms => new Promise(resolve => setTimeout(resolve, ms))
      pause(10).then(() => {
        reader.readAsArrayBuffer(this.file)
      })
    },
    onFileSelect (item) {
      this.item = JSON.parse(JSON.stringify(item))
      this.$refs[item][0].click()
    },
    onReset (item) {
      var index = this.tempGroups.findIndex(group => group.key === item)
      if (index !== -1) {
        this.dataRead(this.tempGroups[index].key)
        this.calcVA()
        this.modify[item] = false
      }
    },
    onDismissed: function (result) {
      this.dialog = false
      if (result) {
        this.$nextTick(function () {
          this.onUpdate()
        })
      }
    },
    onUpdate () {
      var vm = this
      this.loading = true
      this.$nextTick(function () {
        var payload = JSON.parse(JSON.stringify(this.items[this.store]))
        payload.key = null
        payload.revision += 1
        payload.year = vm.year
        payload.author = vm.data.key
        for (var x = 0; x < 12; x++) {
          var keys = Object.keys(payload[x])
          for (var k in keys) {
            payload[x][keys[k]] = {
              value: payload[x][keys[k]].value
            }
          }
        }
        payload.groups[this.store] = true
        payload.schools[vm.school.key] = true
        vm.storeEvent(payload).then(() => {
          vm.modify[this.store] = false
          vm.dataRead(this.store)
          vm.calcVA()
          vm.loading = false
        })
      })
    },
    storeEvent (item) {
      var vm = this
      var path = 'metricsFees/write'
      return new Promise((resolve) => {
        var payload = JSON.parse(JSON.stringify(item))
        if (item.key) {
          payload.updatedAt = parseInt(new Date().getTime())
        } else {
          payload.createdAt = payload.updatedAt = parseInt(new Date().getTime())
        }
        vm.$store.dispatch(path, JSON.parse(JSON.stringify(payload))).then((resp) => {
          resolve()
        })
      })
    }
  }
}
</script>

<style scoped>
.b-B-TITLE {
  border-bottom: 1px solid #1976D2 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.b-R {
  border-right: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L {
  border-left: 1px solid white !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T {
  border-top: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B {
  border-bottom: 1px solid white !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-R-GREY {
  border-right: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-L-GREY {
  border-left: 1px solid #80808080 !important;
  border-left-width: 1px;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-T-GREY {
  border-top: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.b-B-GREY {
  border-bottom: 1px solid #80808080 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

input[type="file"] {
  display: none;
}
.select-none {
  user-select: none;
}

.v-sheet.title-orange {
  background-color: #F0F4C3;
  border: 1px solid white;
  color: #827717;
  height: 20px;
}
</style>
